<template>
  <PageSecondary class="burnout">
    <template #title>Sun Wood Tower</template>
    <h4>Яные дни</h4>
    <p>Сколько солнечных дней в твоём городе? А зимой? В Москве 75% дней без солнца.</p>
    <ul>
      <li>Яркий солнечный свет днём и темнота ночью влияют на выработку мелатонина</li>
      <li>Мелатонин — это гормон, доносящий до органов и тканей информацию о дневном/ночном циклах</li>
      <li>Организму естественно просыпаться от света и засыпать в темноте</li>
      <li>Включая электрический свет перед сном - подавляется мелатонин</li>
      <li>Нехватка света днём не даёт организму полноценно взбодриться</li>
    </ul>
    <ImgBlock asset="media/sun-wood-tower.png" />
    <p>Характеристики</p>
    <ul>
      <li>5500 Lumen</li>
      <li>99 CRI</li>
      <li>4000K</li>
      <li>Массив дуба</li>
      <li>1000 х 200 х 200</li>
    </ul>
    <p>54000₽</p>
  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";
import ImgBlock from "@/components/blocks/ImgBlock";

export default {
  name: "SunWoodTower",
  components: {ImgBlock, PageSecondary}
}
</script>

<style lang="scss" scoped>
.burnout {
  span, p {
    display: block;
    margin-top: 24px;
  }

  img {
    width: 100%;
    margin-top: 24px;
  }

  h4 {
    margin-top: 40px;
  }
}

.definition {

}
</style>
